import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import logo from "assets/img/slide/logo_white.png";
import { PASSWORD_RESET } from "constants/routes";
import { getAuth, RecaptchaVerifier } from "firebase/auth";
import React, { useEffect } from "react";
import { Link as RouterLink } from "react-router";
import AuthCard from "views/Auth/AuthCard";

export default function LoginForm(props) {
  const {
    isExplorer,
    renderRecaptcha,
    loading,
    handleChange,
    user,
    setLoginSubmitted,
  } = props;

  const auth = getAuth();

  useEffect(() => {
    window.recaptchaVerifier = new RecaptchaVerifier(auth, "submit-button", {
      size: "invisible",
      badge: "bottomright",
      callback: () => {
        setLoginSubmitted(true);
      },
    });

    renderRecaptcha();
    // eslint-disable-next-line
  }, [auth]);

  return (
    <AuthCard header={<img src={logo} alt="Slide" style={{ height: 100 }} />}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Login
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Sign into your account
      </Typography>
      <TextField
        label="Email"
        name="user"
        fullWidth
        value={user.user}
        onChange={handleChange}
        margin="normal"
        disabled={isExplorer}
      />
      <TextField
        label="Password"
        type="password"
        name="password"
        fullWidth
        value={user.password}
        onChange={handleChange}
        margin="normal"
        disabled={isExplorer}
      />
      <Grid
        container
        spacing={2}
        sx={{
          alignItems: "center",
        }}
      >
        <Grid size={6}>
          <Link component={RouterLink} to={PASSWORD_RESET} underline="hover">
            Forgot password?
          </Link>
        </Grid>
        <Grid size={6}>
          <Button
            loading={loading}
            id="submit-button"
            fullWidth
            variant="contained"
            disabled={isExplorer}
          >
            Login
          </Button>
        </Grid>
      </Grid>
    </AuthCard>
  );
}
